// Excel export / import of Echipamente (server: equipments/equipmentBulk)
import axios from '@/store/interceptor';
import apiUrl from '../../config/api.config';
import { DateTime } from 'luxon';

// A blob response that is really a JSON error: its message (Romanian), else the fallback
export async function blobErrorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    try {
        if (data instanceof Blob) {
            const parsed = JSON.parse(await data.text());
            const message = parsed && parsed.message;
            if (message) return Array.isArray(message) ? message.join('; ') : message;
        } else if (data && data.message) {
            return Array.isArray(data.message) ? data.message.join('; ') : data.message;
        }
    } catch (e) {
        // not JSON
    }
    if (error && error.response && error.response.status === 403) return 'Nu aveți dreptul să faceți această acțiune.';
    return fallback;
}

function fileNameOf(response, fallback) {
    const header = response.headers && response.headers['content-disposition'];
    const match = header && /filename="?([^";]+)"?/i.exec(header);
    return match ? match[1] : fallback;
}

function saveBlob(blob, name) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
}

// "Export Excel": the rows the caller sees on Echipamente, with the page's department chip and search text
export async function exportEquipments({ department, search } = {}) {
    const params = {};
    if (department) params.department = department;
    if (search && search.trim()) params.search = search;
    const response = await axios.get(`${apiUrl}/equipments/export`, { params, responseType: 'blob' });
    saveBlob(response.data, fileNameOf(response, `Evidenta_echipamente_${DateTime.now().toFormat('yyyy-MM-dd')}.xlsx`));
}

// QR stickers: what the items are today (tag, type, model, seria), in the order given; deleted ones in `missing`
export async function fetchStickerRows(ids) {
    const response = await axios.post(`${apiUrl}/equipments/stickers`, { ids });
    return response.data;
}

export async function downloadImportTemplate() {
    const response = await axios.get(`${apiUrl}/equipments/import/template`, { responseType: 'blob' });
    saveBlob(response.data, fileNameOf(response, 'Sablon_import_echipamente.xlsx'));
}

function form(file, fields = {}) {
    const data = new FormData();
    Object.entries(fields).forEach(([key, value]) => data.append(key, String(value)));
    data.append('file', file, file.name);
    return data;
}

// Every row checked, nothing saved: { fileName, fileHash, alreadyImported, total, valid, duplicates, invalid,
// rows: [{ row, ok, errors, warnings, duplicateOf, ... }] }
export async function previewImport(file) {
    const response = await axios.post(`${apiUrl}/equipments/import/preview`, form(file));
    return response.data;
}

// The same file again: re-checked, the valid rows saved in one go (+ imported, rows[].id / tag). Rows that look
// already imported (duplicateOf) only with includeDuplicates; a file imported before is refused (409 ALREADY_IMPORTED).
export async function commitImport(file, { includeDuplicates = false } = {}) {
    const response = await axios.post(`${apiUrl}/equipments/import/commit`, form(file, includeDuplicates ? { includeDuplicates: 1 } : {}));
    return response.data;
}
